import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { AbstractHypeService } from '../../../Common/Layout/services/abstract-hype.service';

/**
 * Drives the hype page shown while the account has no agents yet. The call to action is relayed
 * rather than handled here, because opening the create panel belongs to the page that owns it.
 */
@Injectable()
export class AutomationAgentsHypeService extends AbstractHypeService {

    private newAgentSubject: Subject<void> = new Subject<void>();
    readonly newAgentRequested$: Observable<void> = this.newAgentSubject.asObservable();

    constructor() {
        super();

        this.hypeConfig = {
            icon: 'fa-kit-duotone fa-agpr-ai-generic',
            headingText: 'AutomationAgents.hype.headline',
            line1Text: 'AutomationAgents.hype.line1',
            linkText: 'AutomationAgents.hype.link',
            hideButtonIcon: true
        };
        this.hypeConfigProvider.next(this.hypeConfig);
    }

    buttonClicked(): void {
        this.newAgentSubject.next();
    }

    secondaryButtonClicked(): void {}
}
